import React, { createContext, useContext } from 'react';

import { Languages } from '../../models/translations';

export const initialLanguage: Languages = Languages.EN;

type Context = [Languages, React.Dispatch<React.SetStateAction<Languages>>];

export const LanguageContext = createContext<Context>([
  initialLanguage,
  () => {
    // no-op dispatch function
  },
] as Context);

export const useLanguageContext = (): Context => useContext(LanguageContext) as Context;
